import { Outlet } from 'react-router-dom'

import { Admin, Auth } from 'Components/Layout'
import { Lazy } from 'Components/Loader'

import Password from 'Components/FormGroup/Password'

const admin = [
    {
        path: 'admin',
        element: <Auth guard="admin" />,
        children: [
            { path: 'verify-email', element: <Lazy view="Auth/VerifyEmail" /> },
            { path: 'verify-email/:id/:hash', element: <Lazy view="Auth/VerifyEmail" /> },
        ],
    },
    {
        path: 'admin',
        element: <Admin guard="admin" />,
        children: [
            { path: '', element: <Lazy view="Admin/Dashboard" /> },
            { path: 'profile', element: <Lazy view="Admin/Dashboard/Profile" /> },
            { path: 'password', element: <Password /> },
            { path: 'login-history', element: <Lazy view="Admin/Dashboard/LoginHistory" title="Login History" /> },
            {
                path: 'admins',
                element: <Outlet />,
                children: [
                    { path: '', element: <Lazy view="Admin/Admins/List" /> },
                    { path: 'create', element: <Lazy view="Admin/Admins/Create" title="Add new" /> },
                    { path: ':id/edit', element: <Lazy view="Admin/Admins/Create" title="Edit" /> },
                ],
            },
            {
                path: 'roles',
                element: <Outlet />,
                children: [
                    { path: '', element: <Lazy view="Admin/Roles/List" /> },
                    { path: 'create', element: <Lazy view="Admin/Roles/Create" title="Add new" /> },
                    { path: ':id/edit', element: <Lazy view="Admin/Roles/Create" title="Edit" /> },
                ],
            },
            {
                path: 'users',
                element: <Outlet />,
                children: [
                    { path: '', element: <Lazy view="Admin/Users/List" /> },
                    { path: 'create', element: <Lazy view="Admin/Users/Create" title="Add new" /> },
                    { path: ':id/edit', element: <Lazy view="Admin/Users/Create" title="Edit" /> },
                ],
            },
            {
                path: 'stores',
                element: <Outlet />,
                children: [
                    { path: '', element: <Lazy view="Admin/Stores/List" /> },
                    { path: 'create', element: <Lazy view="Admin/Stores/Create" title="Add new" /> },
                    { path: ':id/edit', element: <Lazy view="Admin/Stores/Create" title="Edit" /> },
                ],
            },
            {
                path: 'store-users',
                element: <Outlet />,
                children: [
                    { path: '', element: <Lazy view="Admin/StoreUsers/List" /> },
                    { path: 'create', element: <Lazy view="Admin/StoreUsers/Create" title="Add new" /> },
                    { path: ':id/edit', element: <Lazy view="Admin/StoreUsers/Create" title="Edit" /> },
                ],
            },
            {
                path: 'bank-accounts',
                element: <Outlet />,
                children: [
                    { path: '', element: <Lazy view="Admin/BankAccounts/List" /> },
                    { path: 'create', element: <Lazy view="Admin/BankAccounts/Create" title="Add new" /> },
                    { path: ':id/edit', element: <Lazy view="Admin/BankAccounts/Create" title="Edit" /> },
                ],
            },
            {
                path: 'bank-transactions',
                element: <Outlet />,
                children: [
                    { path: '', element: <Lazy view="Admin/BankTransactions/List" /> },
                    { path: 'create', element: <Lazy view="Admin/BankTransactions/Create" title="Add new" /> },
                ],
            },
            {
                path: 'wallet-transactions',
                element: <Outlet />,
                children: [
                    { path: '', element: <Lazy view="Admin/WalletTransactions/List" /> },
                    { path: 'create', element: <Lazy view="Admin/WalletTransactions/Create" title="Add new" /> },
                ],
            },
            {
                path: 'brands',
                element: <Outlet />,
                children: [
                    { path: '', element: <Lazy view="Admin/Brands/List" /> },
                    { path: 'create', element: <Lazy view="Admin/Brands/Create" title="Add new" /> },
                    { path: ':id/edit', element: <Lazy view="Admin/Brands/Create" title="Edit" /> },
                ],
            },
            {
                path: 'categories',
                element: <Outlet />,
                children: [
                    { path: '', element: <Lazy view="Admin/Categories/List" /> },
                    { path: 'create', element: <Lazy view="Admin/Categories/Create" title="Add new" /> },
                    { path: ':id/edit', element: <Lazy view="Admin/Categories/Create" title="Edit" /> },
                ],
            },
            {
                path: 'attributes',
                element: <Outlet />,
                children: [
                    { path: '', element: <Lazy view="Admin/Attributes/List" /> },
                    { path: 'create', element: <Lazy view="Admin/Attributes/Create" title="Add new" /> },
                    { path: ':id/edit', element: <Lazy view="Admin/Attributes/Create" title="Edit" /> },
                ],
            },
            {
                path: 'expenses',
                element: <Outlet />,
                children: [
                    { path: '', element: <Lazy view="Admin/Expenses/List" /> },
                    { path: 'create', element: <Lazy view="Admin/Expenses/Create" title="Add new" /> },
                    { path: ':id/edit', element: <Lazy view="Admin/Expenses/Create" title="Edit" /> },
                ],
            },
            {
                path: 'customers',
                element: <Outlet />,
                children: [
                    { path: '', element: <Lazy view="Admin/Customers/List" /> },
                    { path: 'create', element: <Lazy view="Admin/Customers/Create" title="Add new" /> },
                    { path: ':id/edit', element: <Lazy view="Admin/Customers/Create" title="Edit" /> },
                ],
            },
            {
                path: 'vendors',
                element: <Outlet />,
                children: [
                    { path: '', element: <Lazy view="Admin/Vendors/List" /> },
                    { path: 'create', element: <Lazy view="Admin/Vendors/Create" title="Add new" /> },
                    { path: ':id/edit', element: <Lazy view="Admin/Vendors/Create" title="Edit" /> },
                ],
            },
            {
                path: 'referrals',
                element: <Outlet />,
                children: [
                    { path: '', element: <Lazy view="Admin/Referrals/List" /> },
                    { path: 'create', element: <Lazy view="Admin/Referrals/Create" title="Add new" /> },
                    { path: ':id/edit', element: <Lazy view="Admin/Referrals/Create" title="Edit" /> },
                ],
            },
            {
                path: 'products',
                element: <Outlet />,
                children: [
                    { path: '', element: <Lazy view="Admin/Products/List" /> },
                    { path: 'create', element: <Lazy view="Admin/Products/Create" title="Add new" /> },
                    { path: ':id/edit', element: <Lazy view="Admin/Products/Create" title="Edit" /> },
                ],
            },
            {
                path: 'purchases',
                element: <Outlet />,
                children: [
                    { path: '', element: <Lazy view="Admin/Purchases/List" /> },
                    { path: 'create', element: <Lazy view="Admin/Purchases/Create" title="Add new" /> },
                    { path: ':id/edit', element: <Lazy view="Admin/Purchases/Create" title="Edit" /> },
                ],
            },
            {
                path: 'store-orders',
                element: <Outlet />,
                children: [
                    { path: '', element: <Lazy view="Admin/StoreOrders/List" /> },
                    { path: 'create', element: <Lazy view="Admin/StoreOrders/Create" title="Add new" /> },
                    { path: ':id/edit', element: <Lazy view="Admin/StoreOrders/Create" title="Edit" /> },
                ],
            },
            {
                path: 'orders',
                element: <Outlet />,
                children: [
                    { path: '', element: <Lazy view="Admin/Orders/List" /> },
                    { path: 'create', element: <Lazy view="Admin/Orders/Create" title="Add new" /> },
                    { path: ':id/edit', element: <Lazy view="Admin/Orders/Create" title="Edit" /> },
                ],
            },
            {
                path: 'analysis',
                element: <Outlet />,
                children: [
                    { path: 'purchases', element: <Lazy view="Admin/Analysis/Purchases" /> },
                    { path: 'store-orders', element: <Lazy view="Admin/Analysis/StoreOrders" /> },
                    { path: 'orders', element: <Lazy view="Admin/Analysis/Orders" /> },
                    { path: 'returns', element: <Lazy view="Admin/Analysis/Returns" /> },
                ],
            },
        ],
    },
]

export default admin
